import router from '@/router'
import use187WatchAction from '@/composables/watchActions/use187WatchAction'
import use4WatchAction from '@/composables/watchActions/use4WatchAction'
import useResidencyWatchAction from '@/composables/watchActions/useResidencyWatchAction'
import use401WatchAction from '@/composables/watchActions/use401WatchAction'
import use407WatchAction from '@/composables/watchActions/use407WatchAction'
import use713WatchAction from '@/composables/watchActions/use713WatchAction'
import use714WatchAction from '@/composables/watchActions/use714WatchAction'
import use873WatchAction from '@/composables/watchActions/use873WatchAction'
import use663WatchAction from '@/composables/watchActions/use663WatchAction'
import use739WatchAction from '@/composables/watchActions/use739WatchAction'
import use762WatchAction from '@/composables/watchActions/use762WatchAction'
import useIssueVisaWatchAction from '@/composables/watchActions/useIssueVisaWatchAction'
import useVisaWatchAction from '@/composables/watchActions/useVisaWatchAction'
import useIcaServiceWatchAction from '@/composables/watchActions/useIcaServiceWatchAction'
import useDeliveryWatchAction from '@/composables/watchActions/useDeliveryWatchAction'
import useGccEidaRequestWatchAction from '@/composables/watchActions/useGccEidaRequestWatchAction'

export default function () {
  const serviceId = +router.currentRoute.value.params.serviceId
  if (serviceId === 714) {
    return use714WatchAction()
  }
  if (serviceId === 713) {
    return use713WatchAction()
  }
  if (serviceId === 407) {
    return use407WatchAction()
  }
  if (serviceId === 873) {
    return use873WatchAction()
  }
  if ([70, 71, 121, 122, 406, 443, 993].includes(serviceId)) {
    return useResidencyWatchAction()
  }
  if (serviceId === 401) {
    return use401WatchAction()
  }
  if (serviceId === 187) {
    return use187WatchAction()
  }
  if (serviceId === 4) {
    return use4WatchAction()
  }
  if (
    [
      4, 8, 10, 15, 17, 25, 42, 46, 47, 48, 49, 453, 458, 459, 463, 482, 483, 518, 637, 783, 936,
      949
    ].includes(serviceId)
  ) {
    return use4WatchAction()
  }
  if (
    [
      37, 413, 995, 632, 633, 635, 636, 639, 753, 926, 928, 933, 950, 951, 952, 1005, 1006, 1007,
      1008, 1009, 1010, 1104, 1105
    ].includes(serviceId)
  ) {
    return useVisaWatchAction()
  }
  if ([561, 571, 572, 580, 1058].includes(serviceId)) {
    return useDeliveryWatchAction()
  }
  if (serviceId === 663) {
    return use663WatchAction()
  }
  if (serviceId === 739) {
    return use739WatchAction()
  }
  if (serviceId === 762) {
    return use762WatchAction()
  }
  if ([432, 763, 783, 784, 939, 941, 942, 944, 945, 946, 962].includes(serviceId)) {
    return useIssueVisaWatchAction()
  }
  if ([502, 503, 556, 571, 572, 580, 900].includes(serviceId)) {
    return useIcaServiceWatchAction()
  }
  if ([573, 574, 575].includes(serviceId)) {
    return useGccEidaRequestWatchAction()
  }
}
